'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const WifiOffIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.6702 17.8729C12.7435 16.9462 11.2564 16.9462 10.3297 17.8729L12 19.5432L13.6702 17.8729Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.57117 2.57111L21.4289 21.4289M15.7285 15.8254C13.6703 13.7672 10.3406 13.7672 8.28237 15.8254M18.4117 13.1422C17.194 11.9246 15.7177 11.1271 14.1552 10.75M10.5992 10.5991C8.76729 10.8901 7.00005 11.7306 5.58841 13.1422M21.1272 10.4267C18.3363 7.63576 14.5755 6.38576 10.9332 6.68749M7.47418 7.47412C5.80393 8.09912 4.23065 9.0905 2.88367 10.4375",
          stroke: "currentColor"
        }
      )
    ]
  }
);
const VpWifiOffIcon = forwardRef(WifiOffIcon);

export { VpWifiOffIcon as default };
